import { render, staticRenderFns } from "./HomeCover.vue?vue&type=template&id=5c0dee66&scoped=true"
import script from "./HomeCover.vue?vue&type=script&lang=js"
export * from "./HomeCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0dee66",
  null
  
)

export default component.exports